import React from 'react';

/* Useful little hook to give access to previous props or state */
const usePrevious = (prevProp) => {
  // create a ref
  const ref = React.useRef();
  React.useEffect(() => {
    // ref is assigned to the prop / state passed in
    ref.current = prevProp;
  });
  // old value is returned
  return ref.current;
};
export default usePrevious;
